module.exports = __webpack_public_path__ + "img/status-eveywhere.68c2c1fc.png";